import React, { createContext, useState} from "react";

const UserPreferencesContext = createContext();

const UserPreferencesProvider = ({ children }) => {
    const [preferences, setPreferences] = useState({});

    const updatePreferences = (newPreferences) => {
        setPreferences((prevPreferences) => ({
            ...prevPreferences,
            ...newPreferences,
        }));
    };

    return (
        <UserPreferencesContext.Provider value={{ preferences, updatePreferences }}>
            {children}
        </UserPreferencesContext.Provider>
    );
};

export { UserPreferencesContext, UserPreferencesProvider };
